export const gradient = "bg-linear-to-br from-violet-600 to-[#379fe7]";
